import React from 'react';
import InnerCard from '../../../../../components/InnerCard/InnerCard';
import InfoCell from '../../../../../components/InfoCell/InfoCell';
import { upperCaseFirst } from '../../../../../../../helpers/upperCaseFirst';
import useParameterTextWithArea from '../../../../../hooks/useParameterText';
import styles from '../RoomBlock.module.scss';

const formatRuCurrency = (num) => {
  const formattedRub = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
  }).format(num);

  return formattedRub.slice(0, -2);
};

const Info = ({ room = {} }) => {
  const areaText = useParameterTextWithArea(room.area);

  return (
    <InnerCard className={styles.infoInnerCard}>
      <div className={styles.cellsWrap}>
        <InfoCell title="Этаж" text={room.floor ?? '-'} />
        <InfoCell title="Номер" text={room.number ?? '-'} />
        <InfoCell title="Площадь" text={areaText} />
      </div>
      <InfoCell
        title="Стоимость аренды"
        text={
          room.totalPrice ? `${formatRuCurrency(room.totalPrice)} руб.` : '-'
        }
        additionalText={
          room.price ? (
            <>
              — {formatRuCurrency(room.price)} р/м<sup>2</sup>
            </>
          ) : undefined
        }
      />
      <InfoCell
        title="Тип помещения"
        text={room.type?.name ? upperCaseFirst(room.type.name) : '-'}
      />
      <InfoCell title="Кадастровый номер" text={room.cadastralNumber || '-'} />
    </InnerCard>
  );
};

export default Info;
